export default "__VITE_ASSET__BwU2qnp2__"